import React, { useContext } from "react";
import { Box } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import { AppInfoContext } from "../../../../../App";
import lazyWithRetry from "./lazyWithRetry";

const overlay = {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1300,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(0, 0, 0, 0.25)",
};

const button = (primary) => ({
  border: "1px solid #21538f",
  background: primary ? "#21538f" : "#fff",
  color: primary ? "#fff" : "#21538f",
  fontSize: 12,
  padding: "5px 14px",
  cursor: "pointer",
});

function ModalLoadError({ retry }) {
  const { setAppInformation } = useContext(AppInfoContext);
  const close = () =>
    setAppInformation((prev) => ({
      ...prev,
      waterManagement: { ...prev.waterManagement, showWaterMonitoringMainModal: false },
    }));

  return (
    <Box sx={overlay}>
      <Box
        sx={{
          background: "#fff",
          padding: "20px 24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <Box component="span" sx={{ fontSize: 14, color: "#40494d" }}>
          Dijagram nije učitan.
        </Box>
        <Box sx={{ display: "flex", gap: "8px" }}>
          <Box component="button" type="button" sx={button(true)} onClick={retry}>
            Pokušaj ponovo
          </Box>
          <Box component="button" type="button" sx={button(false)} onClick={close}>
            Zatvori
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default lazyWithRetry(() => import("./WaterMonitoringMainModal"), {
  fallback: (
    <Box sx={overlay}>
      <ClipLoader color="#fff" loading size={60} />
    </Box>
  ),
  renderError: (retry) => <ModalLoadError retry={retry} />,
});
